import clsx from "clsx";
import { Icon } from "../Icon";

type Props = Readonly<{
  children: React.ReactNode;
  className?: string;
  trigger?: React.ReactNode;
  position?: "bottom-middle" | "top-right";
}>;

const positions = {
  "bottom-middle": "top-8 right-1/2 translate-x-1/2",
  "top-right": "left-full translate-x-2 top-0",
};

export const Tooltip = ({ children, className, trigger, position = "top-right" }: Props) => {
  const tooltipTrigger = trigger ?? <Icon name="Help" className="text-raven opacity-70" />;

  return (
    <div className={clsx("group relative inline-flex align-middle", className)}>
      {tooltipTrigger && <span className="outline-none">{tooltipTrigger}</span>}
      <div
        className={clsx(
          "invisible absolute z-10 w-max max-w-80 transform rounded-md border border-background-secondary bg-background-primary px-4 py-4 text-sm font-normal text-body opacity-0 shadow-box-tertiary transition-[visibility,opacity] group-hover:visible group-hover:opacity-100 group-focus-within:visible group-focus-within:opacity-100 sm:max-w-[32rem]",
          positions[position],
        )}
      >
        <span>{children}</span>
      </div>
    </div>
  );
};
